import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMessageFromError } from "../../../shared/welda/services/utilsService";
import errorHandling from "../errorHandling";
import NotificationService from "./notificationService";

const initialState = {
  templates: [],
  labels: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const sendNotifications = createAsyncThunk(
  "notification/sendNotifications",
  async (data, thunkAPI) => {
    try {
      const awaitSendNotifications =
        await NotificationService.sendNotifications(data);
      return awaitSendNotifications;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const GetLabels = createAsyncThunk(
  "notification/getLabels",
  async (thunkAPI) => {
    try {
      const awaitGetLabels = await NotificationService.GetLabels();
      return awaitGetLabels;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const NewLabel = createAsyncThunk(
  "notification/NewLabel",
  async (data, thunkAPI) => {
    try {
      const awaitNewLabel = await NotificationService.NewLabel(data);
      return awaitNewLabel;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const UpdateLabel = createAsyncThunk(
  "notification/UpdateLabel",
  async (data, thunkAPI) => {
    try {
      const awaitUpdateLabel = await NotificationService.UpdateLabel(data);
      return awaitUpdateLabel;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const DeleteLabel = createAsyncThunk(
  "notification/DeleteLabel",
  async (data, thunkAPI) => {
    try {
      const awaitDeleteLabel = await NotificationService.DeleteLabel(data);
      return awaitDeleteLabel;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

///////// TEMPLATE //////////

export const GetTemplates = createAsyncThunk(
  "notification/getTemplates",
  async (thunkAPI) => {
    try {
      const awaitGetTemplates = await NotificationService.GetTemplates();
      return awaitGetTemplates;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const NewTemplate = createAsyncThunk(
  "notification/NewTemplate",
  async (data, thunkAPI) => {
    try {
      const awaitNewTemplate = await NotificationService.NewTemplate(data);
      return awaitNewTemplate;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const UpdateTemplate = createAsyncThunk(
  "notification/UpdateTemplate",
  async (data, thunkAPI) => {
    try {
      const awaitUpdateTemplate = await NotificationService.UpdateTemplate(
        data
      );
      return awaitUpdateTemplate;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const DeleteTemplate = createAsyncThunk(
  "notification/DeleteTemplate",
  async (data, thunkAPI) => {
    try {
      const awaitDeleteTemplate = await NotificationService.DeleteTemplate(
        data
      );
      return awaitDeleteTemplate;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    reset: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotifications.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(sendNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(sendNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(GetLabels.pending, (state) => {})
      .addCase(GetLabels.fulfilled, (state, action) => {
        state.labels = action.payload;
      })
      .addCase(GetLabels.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(NewLabel.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(NewLabel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(NewLabel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(UpdateLabel.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(UpdateLabel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(UpdateLabel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(DeleteLabel.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(DeleteLabel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(DeleteLabel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(GetTemplates.pending, (state) => {})
      .addCase(GetTemplates.fulfilled, (state, action) => {
        state.templates = action.payload;
      })
      .addCase(GetTemplates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(NewTemplate.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(NewTemplate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(NewTemplate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(UpdateTemplate.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(UpdateTemplate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(UpdateTemplate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(DeleteTemplate.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(DeleteTemplate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(DeleteTemplate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { reset } = notificationSlice.actions;
export default notificationSlice.reducer;
